import * as _ from 'lodash';
export const isFontWithoutValue = (font) => {
    if (font.value) {
        return false;
    }
    const family = font.family || font.cssFontFamily;
    return !!family;
};
const defaultFontStyle = {
    bold: false,
    italic: false,
    underline: false,
};
export const calculateFont = (font) => {
    const fontStyle = font.style || defaultFontStyle;
    const family = font.family || font.cssFontFamily;
    const style = fontStyle.italic ? 'italic' : 'normal';
    const variant = 'normal';
    const weight = fontStyle.bold ? 'bold' : 'normal';
    const lineHeight = '1.4em';
    let size = font.size || 'normal';
    if (_.isNumber(size)) {
        size = `${size}px`;
    }
    const isResponsiveValue = size.slice(-3) === 'spx';
    if (isResponsiveValue) {
        size = `${size.slice(0, -3)}px`;
    }
    return `font: ${style} ${variant} ${weight} ${size}/${lineHeight} ${family};`;
};
//# sourceMappingURL=font.js.map